module.exports = __webpack_public_path__ + "img/26exp.1051a828.jpg";